module.exports = __webpack_public_path__ + "img/178.8b0c1d17.jpg";